import React from 'react';
import styles from './subscribeFeaturesTableStyles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

const SubscribeFeaturesTable = () => {
  return (
    <div className={styles.responsiveTable}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th colSpan="4">Plan Overview</th>
          </tr>
          <tr>
            <th />
            <th>Lite</th>
            <th>Premium</th>
            <th>Elite</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Access to Stock Reports Written By Hedge Fund Managers</td>
            <td>
              5 credits <br /> Choose your own ideas
            </td>
            <td>
              35 credits <br /> Choose your own ideas
            </td>
            <td>
              Entire research database <br />
              (~15k ideas)
            </td>
          </tr>
          <tr>
            <td>Access Annual Top Stocks Report</td>
            <td />
            <td>(Winners & Runner Ups)</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Access to Portfolio Manager's Commentary on Investments Reports</td>
            <td>Limited</td>
            <td>Limited</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Access to All of Short Ideas</td>
            <td />
            <td />
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Invites to 'Fireside Chats'</td>
            <td />
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Direct Access to All of Contest Submissions</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Filter for Investment Ideas By Top Ranked Members</td>
            <td>Limited</td>
            <td>Limited</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Screen for Top Rated Ideas</td>
            <td>Limited</td>
            <td>Limited</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Customize and Monitor Research Contributed on Your Portfolio</td>
            <td>Limited</td>
            <td>Limited</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Access to Consensus Tool</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Follow Top Ranked Members and Track Their New Ideas</td>
            <td>Limited</td>
            <td>Limited</td>
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Weekly Round Up of Trending and Most Viewed Ideas</td>
            <td />
            <td />
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Emails Detailing Activity Around Names in Your Portfolio</td>
            <td>Monthly</td>
            <td>Monthly</td>
            <td>Weekly</td>
          </tr>
          <tr>
            <td>Emails Highlighting Unique Investment Opportunities Across SumZero</td>
            <td />
            <td>Monthly</td>
            <td>Weekly</td>
          </tr>
          <tr>
            <td>Receive Special Reports</td>
            <td />
            <td />
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
          <tr>
            <td>Dedicated Rep</td>
            <td />
            <td />
            <td>
              <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SubscribeFeaturesTable;
